import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getDeepValue as t } from "./object.js";

function e(e, s) {
  return e.replace(/\$\{([^\s\:\}]*)(?:\:([^\s\:\}]+))?\}/g, function (e, n) {
    if ("" === n) return "$";
    var i = t(n, s),
        r = null == i ? "" : i;
    if (void 0 === r) throw new Error("could not find key \"".concat(n, "\" in template"));
    return r.toString();
  });
}

var s = /*#__PURE__*/function () {
  function s(t, n, i) {
    _classCallCheck(this, s);

    this.name = t, this.details = i, this.message = void 0, this instanceof s && (this.message = n && e(n, i) || "");
  }

  _createClass(s, [{
    key: "toString",
    value: function toString() {
      return "[" + this.name + "]: " + this.message;
    }
  }]);

  return s;
}();

export { s as default };